import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ErrorMessage } from '@components/error/src/error-message';
import { Input } from '@components/input';
import { LabelPrimary } from '@components/label';
import { emailValidator } from '@utils/validations/text-validators';

export const OptionalMailInput = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();
  return (
    <Controller
      name='email'
      control={control}
      rules={{
        required: false,
        pattern: {
          value: emailValidator,
          message: t('errors:emailFormFieldInvalidFormat'),
        },
      }}
      render={({ field }) => (
        <fieldset>
          <LabelPrimary
            htmlFor={'email'}>{`${t('common:emailFormFieldLabel')} ${t('common:optionalLabel')}`}</LabelPrimary>
          <Input
            type='email'
            label={t('invitations:email')}
            placeholder={t('common:emailFormFieldPlaceholder')}
            hasError={!!errors.email}
            {...field}
          />
          <ErrorMessage name='email' />
        </fieldset>
      )}
    />
  );
};
